import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {FormGroup, Input, Label} from "reactstrap";


class Witness extends React.Component{
    constructor(props) {
        super(props);
        this.state ={
            NotValid :{},
            stored: {},
            firstname : {},
            name: {},
            Field49AddressStreet:{},
            Field49AddressStreetNumber:{},
            Field49AddressStreetBox:{},
            Field49AddressZip:{},
            Field49AddressTown:{},
            openForm:true,

        }
        this.handleChangeWitn = this.handleChangeWitn.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.toggleForm = this.toggleForm.bind(this)
    }

    // fetch data from local Storage
    componentDidMount() {
        let {index} = this.props
        let storedWitness = JSON.parse(localStorage.getItem("witness"))
      //console.log(storedWitness)
        if (storedWitness && storedWitness[index]){
          //console.log(storedWitness)
            let witn = storedWitness[index]
          //console.log(witn)
            let partialState = {...this.state};
            for ( const [name,value] of Object.entries(witn) ){
              //console.log(name)
                partialState[name][index] = value;
            }
            partialState["stored"][index] = true
            this.setState(partialState);
            this.setState({openForm:false})
        }
    }


    toggleForm(e){
        e.preventDefault()
        this.setState({openForm: !this.state.openForm})
    }

    handleChangeWitn(e){
        const {index} = this.props
        const target = e.target;
        const value = target.value;
        const name = e.target.type === "radio"? target.name.replace(/[0-9]/g, '') : target.name;
        //console.log()
        if (e.target.name === "birthdate"){
            this.AgeCalculation(e)
        }

        let partialState = {...this.state};
        partialState[name][index] = value;
        this.setState(partialState);
        //let sl = par.filter((l, k) => l.label !== '')
        //console.log(sl)
    }

    handleSubmit(evt) {
        evt.preventDefault();
        const {index} = this.props
        let witnObject
        witnObject = {
            firstname: this.state.firstname[index],
            name: this.state.name[index],
            Field49AddressStreet: this.state.Field49AddressStreet[index],
            Field49AddressStreetNumber: this.state.Field49AddressStreetNumber[index],
            Field49AddressStreetBox: this.state.Field49AddressStreetBox[index],
            Field49AddressZip: this.state.Field49AddressZip[index],
            Field49AddressTown: this.state.Field49AddressTown[index]
        }
        //console.log(witnObject)
        this.props.submitWitn(this.props.index, witnObject)
        this.setState({openForm:false, stored:true})
        //console.log(JSON.parse(stringInfo))

    }

    delete(evt,index){
        evt.preventDefault()
        this.props.delete(index);
    }
    render() {
        const {i18n, index, d} = this.props;
        return (
            <div>
                {!this.state.openForm &&
                <div className={"formlevel02"}>
                    <p><strong>{i18n.t("field49Firstname")} :</strong> {this.state.firstname[index]} </p>
                    <p><strong>{i18n.t("field49Name")} :</strong> {this.state.name[index]} </p>
                    <p><strong>{i18n.t("ADDRESSDATA")} :</strong>{this.state.Field49AddressStreet[index]} {this.state.Field49AddressStreetNumber[index]}, {this.state.Field49AddressStreetBox[index]} -
                        {this.state.Field49AddressZip[index]} {this.state.Field49AddressTown[index]}
                    </p>
                    <div className="button-wrapper text-right">
                        <button type="submit" onClick={this.toggleForm}
                                className="btn btn-primary small mr-1">{i18n.t("METTRE A JOUR CES INFORMATIONS")}</button>

                        <button type="submit" onClick={e=>this.delete(e,index)}
                                className="btn btn-outline small auto">&nbsp;<FontAwesomeIcon icon={['fas', 'trash']} />&nbsp;</button>
                    </div>
                </div>
                }
                {this.state.openForm &&
                <div>
                    <div className="formlevel02">
                        <FormGroup className={(this.state.NotValid[index] && this.state.firstname[index] === "") ? "text-danger" : "text"}>
                            <Label htmlFor={"firstname"}>{i18n.t("field49Firstname")}</Label>
                            <Input type="text" maxLength={500} id={"firstname"}
                                   value={this.state.firstname[index]? this.state.firstname[index]: ''}
                                   name="firstname" onChange={e=>this.handleChangeWitn(e)} placeholder={i18n.t("placeholderfield49Firstname")}/>
                        </FormGroup>
                        <FormGroup className={(this.state.NotValid[index] && this.state.name[index] === "")? "text-danger" : "text"}>
                            <Label htmlFor={"name"}
                            >{i18n.t("field49Name")} </Label>
                            <Input type="text" maxLength={500} id={"name"} name="name"
                                   placeholder={i18n.t("placeholderfield49Name") }
                                   value={this.state.name[index]? this.state.name[index]: ''}
                                   onChange={e=>this.handleChangeWitn(e)}/>
                        </FormGroup>
                        <div>
                            <Label for="Field49Address">{i18n.t("ADDRESSDATA")}</Label>
                            <FormGroup className="row py-0">
                                <Label for="Field49AddressStreet" className={"col-sm-2"}>{i18n.t("field49AddressStreet")} </Label>
                                <Input type="text" maxLength={500} className={"col-sm-10"} name={"Field49AddressStreet"} onChange={e => this.handleChangeWitn(e)} value={this.state.Field49AddressStreet[index]? this.state.Field49AddressStreet[index] : ''} placeholder={i18n.t("field49AddressStreet")} />
                            </FormGroup>
                            <FormGroup className="row py-0">
                                <Label for="Field49AddressStreetNumber" className={"col-sm-2"}>{i18n.t("field49AddressStreetNumber")} </Label>
                                <Input type="text" maxLength={500} className={"col-sm-4"} name={"Field49AddressStreetNumber"} onChange={e => this.handleChangeWitn(e)} value={this.state.Field49AddressStreetNumber[index]? this.state.Field49AddressStreetNumber[index] : ''} placeholder={i18n.t("field49AddressStreetNumber")} />
                                <Label  for="Field49AddressStreetBox" className={"col-sm-2"}>{i18n.t("field49AddressStreetBox")}</Label>
                                <Input type="text" maxLength={500} className={"col-sm-4"} name={"Field49AddressStreetBox"} onChange={e => this.handleChangeWitn(e)} value={this.state.Field49AddressStreetBox[index]? this.state.Field49AddressStreetBox[index] : ''} placeholder={i18n.t("field49AddressStreetBox")} />
                            </FormGroup>
                            <FormGroup className="row  py-0">
                                <Label for="Field49AddressZip" className={"col-sm-2"} >{i18n.t("field49AddressZip")} </Label>
                                <Input type="text" maxLength={500} className={"col-sm-10"} name={"Field49AddressZip"} onChange={e => this.handleChangeWitn(e)} value={this.state.Field49AddressZip[index]? this.state.Field49AddressZip[index] : ''} placeholder={i18n.t("field49AddressZip")}/>
                            </FormGroup>
                            <FormGroup className="row  py-0">
                                <Label for="Field49AddressTown" className={"col-sm-2"}>{i18n.t("field49AddressTown")} </Label>
                                <Input type="text" maxLength={500} className={"col-sm-10"} name={"Field49AddressTown"} onChange={e => this.handleChangeWitn(e)} value={this.state.Field49AddressTown[index]? this.state.Field49AddressTown[index] : ''} placeholder={i18n.t("field49AddressTown")}/>
                            </FormGroup>
                        </div>
                        <div className="button-wrapper text-right">
                            <button type="submit" onClick={this.handleSubmit}
                                    className="btn btn-primary small mr-1">{this.state.stored[index] ? i18n.t("METTRE A JOUR CES INFORMATIONS"): i18n.t("AJOUTER CES INFORMATIONS")}</button>
                        </div>

                    </div>
                </div> }
            </div>
        )
    }
}
export default Witness

